import React from 'react'
import { Button, Props } from './Button'

/** @deprecated - Use major variant of Button component from `@chilipiper/design-system/src/new` */
export const PrimaryButton = (props: Props) => {
  return <Button {...props} bg='bg/button-major' color='white' />
}
